/* istanbul ignore file */
import {
  CARD_PRODUCT,
  PERSONAL_CHECKING_ACCOUNT,
  PERSONAL_SAVINGS_ACCOUNT,
} from '@americanexpress/product-ducks';

import { sharedRouteChecks, supportRouteChecks } from './productTypeRoutes';

const getIsValidSharedRoute = (pathName) => sharedRouteChecks.some(
  (regex) => regex.test(pathName)
);
const withIsValidSharedRoute = (func) => (pathName) => func(pathName)
  || getIsValidSharedRoute(pathName);
const getIsValidSupportRoute = (pathName) => supportRouteChecks.some(
  (regex) => regex.test(pathName)
);
const withIsValidSupportRoute = (func) => (pathName) => func(pathName)
  || getIsValidSupportRoute(pathName);
const getIsValidCardRoute = withIsValidSupportRoute(
  withIsValidSharedRoute((pathname) => !pathname.startsWith('/banking'))
);
const getIsValidBankingRoute = withIsValidSupportRoute(
  withIsValidSharedRoute((pathname) => pathname.startsWith('/banking'))
);
const validRoutesByTypeMap = {
  [CARD_PRODUCT]: getIsValidCardRoute,
  [PERSONAL_CHECKING_ACCOUNT]: getIsValidBankingRoute,
  [PERSONAL_SAVINGS_ACCOUNT]: getIsValidSharedRoute,
};

/**
 * Given a type, return a boolean indicating if the product is a supported type.
 * @param {string} type The type of product.
 * The list can be found in constants.js in @americanexpress/axp-product-ducks
 * @returns Returns a boolean indicating if the product is a supported type.
 */
const getIsHandledProduct = (type) => !!validRoutesByTypeMap[type];

/**
 * Given a type and a URL, this function will return a boolean indicating if the URL
 * is supported by the type.
 * @param {string} type The type of product.
 * @param {string} pathName The URL of the route in question.
 * @returns {boolean} A boolean value checking if the route is valid for the given type.
 */
const getIsValidRouteForType = (type, pathName) => {
  const validRouteByType = validRoutesByTypeMap[type];
  return validRouteByType(pathName);
};

export {
  getIsValidBankingRoute,
  getIsValidCardRoute,
  getIsValidSharedRoute,
  getIsValidRouteForType,
  getIsHandledProduct,
};
